import { Icon, Modal, Button, Divider, Spin, List , Collapse} from 'antd';
import Dragger from 'antd/lib/upload/Dragger';
import React from 'react';
  
const { Panel } = Collapse;

export class DocumentUploadModal extends React.Component {
    state={
        files: []

    }
    files = []

    beforeUpload = (file) => {
            if(this.props.multiple){
                this.setState(prevState =>{
                    return{
                         ...prevState,
                         files : [...prevState.files , file]
                    }
                 })
            }else{
                this.setState({
                    files: [file]
                })
            }

            return false;
    }

    onRemove = _ => {
        let files = this.state.files.filter(file => file.uid !== _.uid);
        this.setState({
            files 
        })
    }

    onSubmit = () => {
        this.props.uploadDocument(this.state.files)
        this.setState({
            files: []
        })
    }

    onClose = () => {
        this.props.closeModal()
        this.setState({
            files: []
        })
    }

    draggerProps = {
        name: 'file',
        multiple: this.props.multiple,
        action: null,
        beforeUpload:this.beforeUpload,
        onRemove: this.onRemove,
        showUploadList: false
    };

    render() {
        const {showModal, uploadDocument, view_documents_list, title, loading} = this.props;
        return (
            <Modal
                title={title}
                visible={showModal}
                onCancel={() => this.onClose()}
                footer={<Button key="submit" type="primary" loading={loading} onClick={() => this.onSubmit()}>
                    Submit
                </Button>}
                className='ant-d-dragger'
            >
                {this.props.documents_list && this.props.documents_list.size ? <Collapse
                    expandIconPosition="right"
                >
                    <Panel header="Uploaded Documents" key="1">
                        <List
                            className='header-sticky'
                            loading={!this.props.documents_list}
                            size="small"
                            style={{
                                height: 200,
                                overflow: 'auto',
                                border: '1px solid rgba(140, 140, 140, 0.35)',
                            }}
                            bordered
                            dataSource={this.props.documents_list}
                            renderItem={(_) => <List.Item actions={[<Button type="link" target={"_blank"}
                                href={_.file}
                            >View</Button>]}>{_.file_name}</List.Item>}
                        />          </Panel>
                </Collapse> : <></>
                }

                <Dragger {...this.draggerProps} style={{marginTop: "20px"}}>
                    <p className="ant-upload-drag-icon">
                        <Icon type="cloud-upload" style={{ fontSize: 50 }} />
                    </p>
                    <p className="ant-upload-text">Drag and Drop your files here</p>
                    <p className="ant-upload-hint mt-5">OR</p>
                    <Button key="submit" className='mt-5'>
                        Browse Files
                    </Button>
                </Dragger>
                {this.state.files?.map(el=> {
                    return(
                        <div key={el} className="d-flex justify-content-space-between align-items-center">
                            <span> {el.name} </span>
                            <Icon type="delete" onClick={()=>this.onRemove(el)}/>
                        </div>
                    );})}
            </Modal>
        )
    }
}